import { Button, ButtonLevel, ButtonSize, Tooltip, TooltipTrigger } from '@vizit/atoms';
import { ClockRewindIcon } from '@vizit/icons';
import { colors } from '@vizit/theme';
import { ViewMode, useProductDetails } from '../../providers';

const VIEW_MODE_CONFIG = {
  [ViewMode.EXPERIMENT]: {
    label: 'Show Original',
    nextMode: ViewMode.ORIGINAL,
    level: ButtonLevel.Secondary,
    iconStroke: undefined,
  },
  [ViewMode.ORIGINAL]: {
    label: 'Back to experiment',
    nextMode: ViewMode.EXPERIMENT,
    level: ButtonLevel.Primary,
    iconStroke: colors.brand['300'],
  },
} as const;

/**
 * Toggle button for switching between experiment and original views.
 */
function ProductViewModeToggle() {
  const { viewMode, onViewModeChange, isOriginalAvailable, summary } = useProductDetails();

  if (summary.scoreStatus !== 'SCORED') {
    return null;
  }

  const { label, nextMode, level, iconStroke } = VIEW_MODE_CONFIG[viewMode];

  const handlePress = () => {
    onViewModeChange?.(nextMode);
  };

  const button = (
    <Button
      iconStart={<ClockRewindIcon stroke={iconStroke} />}
      level={level}
      size={ButtonSize.Xs}
      isDisabled={!isOriginalAvailable}
      onPress={handlePress}
      className="gap-3 font-semibold"
      data-testid="product-view-mode-toggle"
    >
      {label}
    </Button>
  );

  if (!isOriginalAvailable) {
    return (
      <TooltipTrigger delay={100}>
        {button}
        <Tooltip>Original PDP is not available</Tooltip>
      </TooltipTrigger>
    );
  }

  return button;
}

export { ProductViewModeToggle };
